import { Input } from "@/components/ui/input";

interface DiscountFieldProps {
  value: number;
  onChange: (value: number) => void;
}

export const DiscountField = ({ value, onChange }: DiscountFieldProps) => {
  return (
    <div className="space-y-2">
      <label htmlFor="discount" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
        Descuento (opcional)
      </label>
      <Input
        type="number"
        id="discount"
        name="discount"
        value={value || ""}
        onChange={(e) => onChange(Number(e.target.value) || 0)}
        placeholder="0"
        min="0"
        step="1"
        className="w-full"
      />
    </div>
  );
};
